import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Account, Channel } from '@/shared/model/scrap-agent.model';

@Component({
  components: { DsModal },
})
export default class MyComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  // @Prop({ type: Object, required: true }) channelConnect!: Channel;

  showModal: boolean = this.open;

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
  }

  @Watch('showModal')
  onShowModalChange(value: boolean) {
    this.$emit('update:open', value);
  }

  handleCloseModal() {
    this.$emit('modal:close');
  }

  handleShowAddAccount() {
    this.$emit('modal:AddAccount');
  }

  handleSubmitAccount(value: Account) {
    this.$emit('modal:SubmitAccount', value);
  }
}
